// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2P8_B","footer":"ModalError_footer__3umPJ"};